import { useEffect, useLayoutEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import moment from 'moment-timezone'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { PopUp, PatientVisitTag, getSpecialVisitTypeGroups } from 'ui_kit_qmd'
import classNames from 'classnames'
import { EventLocations } from 'lib/segment/constants'
import closeIcon from '../../../images/common/close.png'
import calendarIcon from '../../../images/common/calendar.png'
import clockIcon from '../../../images/common/clock.png'
import editIcon from '../../../images/calendar/editIcon.png'
import trashIcon from '../../../images/common/trash.png'
import { resetScheduleInfoRecurring } from '../../../store/calendar/CalendarActions'
import { editSchedule, getScheduleInfo } from '../../../store/calendar/CalendarThunk'
import { ConfirmationPopup } from '../../../components/confirmation-popup/confirmationpopup'
import './DetailsView.scss'
import {
  getAddressStringFromAddressObject,
  getAgeByDate,
  getDays,
  getTabId,
  getVisitStatus,
  isActiveEllipsisCheck,
  isEllipsisActive,
  parseTimeZone,
  replaceTimeZone,
} from '../../../utils/common'
import AppointmentRibbonInfoItem from './AppointmentRibbonInfoItem/AppointmentRibbonInfoItem'
import tabletImg from '../../../images/calendar/calendar-tablet-icon.png'

import {
  APPOINTMENT_ADDITIONAL_INFO_METHOD_OPTION,
  APPOINTMENT_ADDITIONAL_INFO_VISIT_OPTION,
  APPOINTMENT_ADDITIONAL_PATIENT_ADDRESS_OPTION,
  APPOINTMENT_ADDITIONAL_PATIENT_BOOKING_STATE_OPTION,
  APPOINTMENT_ADDITIONAL_VISIT_STATUS_OPTION,
  APPOINTMENT_INFO_ID_CONSTANT_PART,
  APPOINTMENT_INFO_PATIENT_NAME_ROW_ID,
  APPOINTMENT_TYPE_CALL,
  APPOINTMENT_TYPE_PHONE,
  APPOINTMENT_VIEW_TYPE_LABEL,
  DATE_FORMAT_TYPE_DATE,
  DATE_FORMAT_TYPE_TIME,
  DETAILS_INFO_TYPE_AVAILABILITY,
  DETAILS_INFO_TYPE_PNB,
  OVERLAP_DATE_FORMAT,
  PATIENTS_INFO_PREFFERED_NAME_ID,
} from '../../../utils/constants'
import { windowOpenArgs } from 'utils/windowOpenArgs'
import { useSelector } from 'store/hooks/useSelector'

const popUpContainerStyle = {
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  zIndex: 999999999,
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}
const popUpBoxStyle = {
  padding: '32px 24px 32px 24px',
  backgroundColor: '#ffffff',
  borderRadius: 4,
  position: 'relative',
  height: 'auto',
  flexDirection: 'column',
  display: 'flex',
  width: 877,
}

const DetailsView = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setShowDetails,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  detailsInfo,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  customTimeZone,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setShowEditAvailabilityView,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setClickedStartDateTime,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setClickedEndDateTime,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  ViewType,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitTypeGroups,
}) => {
  const dispatch = useDispatch()
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const loading = useSelector((state) => state.calendarPageReducer.loading)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const scheduleInfoRecurring = useSelector((state) => state.calendarPageReducer.scheduleInfoRecurring)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const recurringBaseTimeZone = useSelector((state) => state.calendarPageReducer.recurringBaseTimeZone)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const AppointmentInfo = useSelector((state) => state.calendarPageReducer.AppointmentInfo)
  const { fromDateTime } = detailsInfo
  const { toDateTime } = detailsInfo

  const [isNameWithTooltip, setIsNameWithTooltip] = useState(false)
  const [isNameTooltipVisible, setIsNameTooltipVisible] = useState(false)
  const [showRepeatPopUp, setShowRepeatPopUp] = useState(false)
  const [isOnHoverRepeatPopUp, setIsOnHoverRepeatPopUp] = useState(false)
  const [isPrefferedNameWithTooltip, setIsPrefferedNameWithTooltip] = useState(false)
  const [isPrefferedNameTooltipVisible, setIsPrefferedNameTooltipVisible] = useState(false)
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)
  const profile = useSelector((state) => state.waitingRoomReducer.providerProfile)

  const isAllowEditing = moment().isBefore(moment(toDateTime).parseZone().tz(customTimeZone, true))
  const isVisitWithTag = detailsInfo?.IsNewForServiceType || detailsInfo?.IsNewForPatient
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const matchedGroup = visitTypeGroups?.find((g) => g.VisitTypeGroupId === detailsInfo?.visitTypeGroupId)
  const isSpecial = matchedGroup ? !matchedGroup.IsDefault : false
  const specialGroups = getSpecialVisitTypeGroups(visitTypeGroups)
  const hasMultipleGroups = (visitTypeGroups?.length ?? 0) > 1

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const FormatDate = (date, dateformatType, isKeepLocalTime = true) => {
    const dateTimeZoneAdjusted = moment(date).parseZone().tz(customTimeZone, isKeepLocalTime)

    switch (dateformatType) {
      case DATE_FORMAT_TYPE_DATE:
        return dateTimeZoneAdjusted.format('dddd MMM DD YYYY')
      case OVERLAP_DATE_FORMAT:
        return dateTimeZoneAdjusted.format('dddd MMM DD YYYY, h:mma')
      case DATE_FORMAT_TYPE_TIME:
        return dateTimeZoneAdjusted.format('h:mma')
      default:
        return dateTimeZoneAdjusted.format()
    }
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const checkIsSameDay = (from, to) => {
    const dateWithCurrentTimeZone = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ')
    const adjustedByTimeZoneFromDate = moment(replaceTimeZone(from, dateWithCurrentTimeZone, false, true))
    const adjustedByTimeZoneToDate = moment(replaceTimeZone(to, dateWithCurrentTimeZone, false, true))

    return (
      adjustedByTimeZoneFromDate.date() === adjustedByTimeZoneToDate.date() &&
      adjustedByTimeZoneFromDate.month() === adjustedByTimeZoneToDate.month() &&
      adjustedByTimeZoneFromDate.year() === adjustedByTimeZoneToDate.year()
    )
  }

  const onOpenEditPopUp = () => {
    const fromDateTimeAccordinglyTZ = moment(fromDateTime).parseZone().tz(customTimeZone, true)
    const toDateTimeAccordinglyTZ = moment(toDateTime).parseZone().tz(customTimeZone, true)

    const startTime = {
      displayDate: fromDateTimeAccordinglyTZ.format('dddd MMM D YYYY'),
      displayTime: fromDateTimeAccordinglyTZ.format('hh:mma'),
      dateTime: fromDateTimeAccordinglyTZ.format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
    }
    const endTime = {
      displayDate: toDateTimeAccordinglyTZ.format('dddd MMM D YYYY'),
      displayTime: toDateTimeAccordinglyTZ.format('hh:mma'),
      dateTime: toDateTimeAccordinglyTZ.format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
    }
    setClickedStartDateTime(startTime)
    setClickedEndDateTime(endTime)
    setShowDetails(false)
    if (detailsInfo.type === DETAILS_INFO_TYPE_PNB || detailsInfo.type.includes(DETAILS_INFO_TYPE_AVAILABILITY)) {
      setShowEditAvailabilityView({
        itemId: detailsInfo.id,
        scheduleId: detailsInfo.scheduleId,
        visitTypeGroupId: detailsInfo.visitTypeGroupId,
        scheduleOrder: detailsInfo.scheduleOrder,
        type: detailsInfo.type,
        isRecursive: !!scheduleInfoRecurring,
        EndDateTime: {
          dateTime: scheduleInfoRecurring?.EndDateTime ?? null,
          displayDate: moment(scheduleInfoRecurring?.EndDateTime).format('dddd MMM D YYYY') ?? {},
        },
        RecurringType: scheduleInfoRecurring?.RecurringType ?? {},
        RepeatDays: scheduleInfoRecurring?.WeekDays ?? [],
        OccurrenceStartTime: startTime,
        OccurrenceEndTime: endTime,
      })
    } else {
      setShowEditAvailabilityView({
        itemId: detailsInfo.id,
        type: detailsInfo.type,
        isRecursive: !!scheduleInfoRecurring,
        visitTypeGroupId: detailsInfo.visitTypeGroupId,
        EndDateTime: {
          dateTime: scheduleInfoRecurring?.EndDateTime ?? {},
          displayDate: moment(scheduleInfoRecurring?.EndDateTime).format('dddd MMM D YYYY') ?? {},
        },
        RecurringType: scheduleInfoRecurring?.RecurringType ?? {},
        RepeatDays: scheduleInfoRecurring?.WeekDays ?? [],
      })
    }
  }
  useEffect(() => {
    if (ViewType === APPOINTMENT_VIEW_TYPE_LABEL) {
      if (isEllipsisActive(document.getElementById(APPOINTMENT_INFO_PATIENT_NAME_ROW_ID))) {
        setIsNameWithTooltip(true)
      }
      if (isEllipsisActive(document.getElementById(PATIENTS_INFO_PREFFERED_NAME_ID))) {
        setIsPrefferedNameWithTooltip(true)
      }
    }
    const timer = setInterval(() => {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      isActiveEllipsisCheck('repeat', setShowRepeatPopUp)
    }, 1000)
    return () => clearInterval(timer)
  }, [ViewType, moment])

  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
  useLayoutEffect(() => {
    if (ViewType === APPOINTMENT_VIEW_TYPE_LABEL) {
      /* empty */
    } else if (detailsInfo.scheduleId) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getScheduleInfo(detailsInfo.scheduleId))
    }
    return () => dispatch(resetScheduleInfoRecurring())
  }, [])

  if (loading) {
    return null
  }
  const appointmentAdditionalInfoOptions = [
    {
      name: APPOINTMENT_ADDITIONAL_INFO_VISIT_OPTION,
      value: `${detailsInfo.ServiceTypeName} (${detailsInfo.VisitTypeName})`,
    },
    {
      name: APPOINTMENT_ADDITIONAL_INFO_METHOD_OPTION,
      value: detailsInfo.Method,
    },
    {
      name: APPOINTMENT_ADDITIONAL_PATIENT_ADDRESS_OPTION,
      value: detailsInfo.Patient?.Address ? getAddressStringFromAddressObject(detailsInfo.Patient?.Address) : '--',
    },
    {
      name: APPOINTMENT_ADDITIONAL_VISIT_STATUS_OPTION,
      value: getVisitStatus(detailsInfo?.Status),
    },
    {
      name: APPOINTMENT_ADDITIONAL_PATIENT_BOOKING_STATE_OPTION,
      value: detailsInfo?.StateCode || '--',
    },
  ]

  const onClosePopUp = () => {
    setShowDetails(false)
  }

  // PNB blocks are always single occurrences — the UI never exposes a recurrence
  // option for them — so deletion only ever removes this one occurrence.
  const onConfirmDelete = () => {
    const scheduleInfo = {
      TimeZone: recurringBaseTimeZone || customTimeZone,
      Occurrences: { Delete: [detailsInfo.id] },
    }
    dispatch(editSchedule({ scheduleInfo, eventType: 'unavailability', tabId: getTabId() }))
    setShowDeleteConfirmation(false)
    setShowDetails(false)
  }

  const onClickPatientName = () => {
    const link = `${window.location.origin}/patientcharts/patient?id=${AppointmentInfo?.Patient?.PatientId}&ref=${EventLocations.calendar}`
    window.open(link, ...windowOpenArgs)
  }

  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  if (profile.TimeZone) {
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    moment.tz.setDefault(parseTimeZone(profile.TimeZone))
  }

  const patientNameToolTipBox = { visibility: isNameTooltipVisible ? 'visible' : 'hidden' }

  const availableStates = detailsInfo?.availableStatesCodes

  const applicableRow = availableStates?.join('; ') ?? 'N/A'

  const recurrenceEndDate = FormatDate(
    scheduleInfoRecurring?.EndDateTime ?
      moment(scheduleInfoRecurring?.EndDateTime)
    : moment(detailsInfo?.fromDateTime).add(1, 'year'),
    DATE_FORMAT_TYPE_DATE,
    false,
  )

  return (
    <>
      {showDeleteConfirmation ?
        // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered
        <ConfirmationPopup
          additionalContainerClass='pnb-delete-confirmation-popup'
          title='Please confirm cancellation'
          msg='Deletion does not cancel patients who previously booked during this event.'
          primaryBtnText='Confirm'
          primaryBtnAction={onConfirmDelete}
          secondaryBtnText='Close'
          secondaryBtnAction={() => setShowDeleteConfirmation(false)}
          closeAction={() => setShowDeleteConfirmation(false)}
        />
      : null}
      <PopUp
        popUpContainerStyle={popUpContainerStyle}
        popUpBoxStyle={popUpBoxStyle}
        content={
          ViewType === APPOINTMENT_VIEW_TYPE_LABEL ?
            <>
              <div className='appointment-details-header-container'>
                <div className='availability-details-title'>
                  <div className='patients-main-info-container'>
                    <div className='visit-details-title-container'>
                      <div className='patient-name-container' onClick={onClickPatientName} role='presentation'>
                        <img className='tabletImg' src={tabletImg} alt='tabletImg' />
                        {isNameWithTooltip ?
                          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                          <div style={patientNameToolTipBox} className='patientName-tooltip-box'>
                            {detailsInfo?.FirstName} {detailsInfo.Patient?.LastName}
                          </div>
                        : null}
                        <div
                          onMouseOver={() => {
                            setIsNameTooltipVisible(true)
                          }}
                          onMouseLeave={() => {
                            setIsNameTooltipVisible(false)
                          }}
                          onFocus={() => {}}
                          id={APPOINTMENT_INFO_PATIENT_NAME_ROW_ID}
                          className={classNames('patient-name-row-text', {
                            'patient-name-row-text--with-tag': isVisitWithTag,
                          })}>
                          <div />
                          {detailsInfo.Patient?.FirstName} {detailsInfo.Patient?.LastName}
                        </div>
                        ({getAgeByDate(detailsInfo.Patient?.BirthDate)}/
                        {detailsInfo.Patient?.Gender === 'female' ? 'F' : 'M'})
                      </div>
                      <PatientVisitTag
                        isNewForServiceType={detailsInfo?.IsNewForServiceType}
                        isNewForPatient={detailsInfo?.IsNewForPatient}
                      />
                    </div>
                    <div className='patients-info-subtexts-wrapper'>
                      <div className='patients-info-preffered-name-main-wrapper'>
                        {isPrefferedNameWithTooltip && isPrefferedNameTooltipVisible ?
                          <div className='patients-info-preffered-name-tooltip-box'>
                            {detailsInfo.Patient?.PreferredName}
                          </div>
                        : null}
                        <div className='patients-info-subText patients-info-preffered-name-wrapper'>
                          Preferred name:{' '}
                          <span
                            id={PATIENTS_INFO_PREFFERED_NAME_ID}
                            onFocus={() => {}}
                            className='patients-info-preffered-name'
                            onMouseOver={() => {
                              setIsPrefferedNameTooltipVisible(true)
                            }}
                            onMouseLeave={() => {
                              setIsPrefferedNameTooltipVisible(false)
                            }}>
                            {detailsInfo.Patient?.PreferredName || '--'}
                          </span>
                        </div>
                        <div className='patients-info-subtexts-separator' />
                      </div>
                      <div className='patients-info-subText'>
                        DOB: {moment(detailsInfo.Patient?.BirthDate).format('MM/DD/YYYY')}
                      </div>
                    </div>
                  </div>
                </div>
                <div className='availability-header-right-container'>
                  <img
                    alt='Close'
                    src={closeIcon}
                    className='availability-close-details-img'
                    onClick={onClosePopUp}
                    role='presentation'
                  />
                </div>
              </div>
              <div className='availability-details-container'>
                <div
                  className={
                    checkIsSameDay(detailsInfo.ToDateTime, detailsInfo.FromDateTime) ? 'availability-details-row' : (
                      'availability-details-row-overlap-version'
                    )
                  }>
                  <div className='appointment-details-inner-row'>
                    <img className='availability-detils-img' src={calendarIcon} alt='Date' />
                    {checkIsSameDay(detailsInfo.ToDateTime, detailsInfo.FromDateTime) && (
                      <label htmlFor='null' className='availability-details-text'>
                        {FormatDate(detailsInfo.FromDateTime, DATE_FORMAT_TYPE_DATE, customTimeZone)}
                      </label>
                    )}
                  </div>
                  {checkIsSameDay(detailsInfo.ToDateTime, detailsInfo.FromDateTime) ?
                    <div className='appointment-details-inner-row'>
                      <img className='availability-detils-img' src={clockIcon} alt='Time' />
                      <label htmlFor='null' className='availability-details-text'>
                        {FormatDate(detailsInfo.FromDateTime, DATE_FORMAT_TYPE_TIME, false)} -{' '}
                        {FormatDate(detailsInfo.ToDateTime, DATE_FORMAT_TYPE_TIME, false)}
                      </label>
                    </div>
                  : <div className='appointment-details-inner-row-overlap-version'>
                      <label
                        htmlFor='null'
                        className={
                          checkIsSameDay(detailsInfo.ToDateTime, detailsInfo.FromDateTime) ? 'availability-details-text'
                          : 'appointment-details-text-overlap-version'
                        }>
                        {moment(detailsInfo.FromDateTime).format('dddd MMM DD YYYY, h:mma')} -{' '}
                        {moment(detailsInfo.ToDateTime).format('dddd MMM DD YYYY, h:mma')}
                      </label>
                    </div>
                  }
                </div>
              </div>
              <div className='common-appointment-info-ribbon-container'>
                {appointmentAdditionalInfoOptions.map((t, i) => (
                  <AppointmentRibbonInfoItem
                    // eslint-disable-next-line react/no-array-index-key
                    key={i}
                    id={APPOINTMENT_INFO_ID_CONSTANT_PART + t.name}
                    isWithBorderBottom={
                      // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
                      t.name !== appointmentAdditionalInfoOptions[appointmentAdditionalInfoOptions.length - 1].name
                    }
                    isWithoutCapitalize={
                      t.name === APPOINTMENT_ADDITIONAL_INFO_VISIT_OPTION ||
                      t.name === APPOINTMENT_ADDITIONAL_PATIENT_ADDRESS_OPTION ||
                      t.name === APPOINTMENT_ADDITIONAL_VISIT_STATUS_OPTION
                    }
                    itemName={t.name}
                    itemValue={t.value === APPOINTMENT_TYPE_CALL ? APPOINTMENT_TYPE_PHONE : t.value}
                  />
                ))}
              </div>
            </>
          : <>
              <div className='availability-details-header-container'>
                <label htmlFor='null' className='availability-details-title'>
                  {detailsInfo.type === 'PNB' ? 'Prevent new bookings' : 'Available'}
                </label>
                <div className='availability-header-right-container'>
                  {isAllowEditing ?
                    <img
                      alt='editIcon'
                      src={editIcon}
                      className='edit-img'
                      onClick={onOpenEditPopUp}
                      role='presentation'
                    />
                  : null}
                  {isAllowEditing && detailsInfo.type === DETAILS_INFO_TYPE_PNB ?
                    <img
                      alt='deleteIcon'
                      src={trashIcon}
                      className='delete-img'
                      onClick={() => setShowDeleteConfirmation(true)}
                      role='presentation'
                    />
                  : null}
                  <img
                    role='presentation'
                    alt='Close'
                    src={closeIcon}
                    className='availability-close-details-img'
                    onClick={onClosePopUp}
                  />
                </div>
              </div>
              <div className='availability-details-container'>
                <div
                  className={
                    checkIsSameDay(detailsInfo.toDateTime, detailsInfo.fromDateTime) ? 'availability-details-row' : (
                      'availability-details-row-overlap-version'
                    )
                  }>
                  <div className='availability-details-inner-row'>
                    <img className='availability-detils-img' src={calendarIcon} alt='Date' />
                    {checkIsSameDay(detailsInfo.toDateTime, detailsInfo.fromDateTime) && (
                      <label htmlFor='null' className='availability-details-text'>
                        {FormatDate(detailsInfo.fromDateTime, DATE_FORMAT_TYPE_DATE, customTimeZone)}
                      </label>
                    )}
                  </div>
                  {checkIsSameDay(detailsInfo.toDateTime, detailsInfo.fromDateTime) ?
                    <div className='availability-details-inner-row'>
                      <img className='availability-detils-img' src={clockIcon} alt='Time' />
                      <label htmlFor='null' className='availability-details-text'>
                        {FormatDate(detailsInfo.fromDateTime, DATE_FORMAT_TYPE_TIME, customTimeZone)} -{' '}
                        {FormatDate(detailsInfo.toDateTime, DATE_FORMAT_TYPE_TIME, customTimeZone)}
                      </label>
                    </div>
                  : <div className='availability-details-inner-row-overlap-version'>
                      <label
                        htmlFor='null'
                        className={
                          checkIsSameDay(detailsInfo.toDateTime, detailsInfo.fromDateTime) ? 'availability-details-text'
                          : 'availability-details-text-overlap-version'
                        }>
                        {FormatDate(detailsInfo.fromDateTime, OVERLAP_DATE_FORMAT, customTimeZone)} -{' '}
                        {FormatDate(detailsInfo.toDateTime, OVERLAP_DATE_FORMAT, customTimeZone)}
                      </label>
                    </div>
                  }
                </div>
                <div className='availability-details-line-break' />
                {scheduleInfoRecurring ?
                  <div
                    onFocus={() => {}}
                    className={classNames('availability-details-row', {}, ['withMarginTop'])}
                    onMouseLeave={() => setIsOnHoverRepeatPopUp(false)}
                    onMouseOver={() => setIsOnHoverRepeatPopUp(true)}>
                    <div className='availability-details-inner-row-repeat'>
                      <label htmlFor='null' className='availability-details-text-overlap-version-repeat' id='repeat'>
                        {`Repeats weekly ${
                          scheduleInfoRecurring.RecurringType !== 'daily' ?
                            ` on ${getDays(scheduleInfoRecurring.WeekDays)}`
                          : ''
                        }`}
                      </label>
                    </div>
                    <div className='availability-details-inner-row-end'>
                      <img className='availability-detils-img' src={calendarIcon} alt='Date' />
                      <label htmlFor='null' className='availability-details-text-overlap-version'>
                        End date: {recurrenceEndDate}
                      </label>
                    </div>
                  </div>
                : null}
                {scheduleInfoRecurring ?
                  <div className='availability-details-line-break' />
                : null}
                <div className='appointment-info-applicable-states-section'>
                  {hasMultipleGroups && matchedGroup ?
                    <div
                      className={classNames('availability-details-row', ['availability-label-info', 'cursor-default'])}>
                      Visit type(s):{' '}
                      {
                        isSpecial ?
                          matchedGroup.Name
                          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                        : `All visit types except ${specialGroups.map((g) => g.Name).join(', ')}`
                      }
                    </div>
                  : null}
                  <div
                    className={classNames('availability-details-row', {}, [
                      'availability-label-info',
                      'withMarginTop',
                      'cursor-default',
                    ])}>
                    Applicable state(s): {applicableRow || 'N/A'}
                  </div>
                </div>
              </div>

              {showRepeatPopUp && isOnHoverRepeatPopUp ?
                <div className={classNames('serviceTypeNameBlockTip', {}, ['serviceTypeNameTooltipAdditionalClasses'])}>
                  {`Repeats weekly ${
                    scheduleInfoRecurring.RecurringType !== 'daily' ?
                      ` on ${getDays(scheduleInfoRecurring.WeekDays)}`
                    : ''
                  }`}
                </div>
              : null}
            </>
        }
      />
    </>
  )
}

export default DetailsView
